<template>
  <v-card :loading="loading" color="transparent" flat>
    <v-row v-if="data != null" class="m-3">
      <v-flex class="m-3" md="6" sm="12">
        <div v-if="data.user_info != null">
          <request-details :data="data.user_info"/>
        </div>
        <div v-if="!!data.bussiness">
          <business :request="data"/>
        </div>
      </v-flex>

      <v-flex class="m-3" md="6" sm="12">
        <user-details :details="data"/>
      </v-flex>
    </v-row>

    <v-divider class="mt-4"/>

    <transition mode="out-in" name="slide-y-reverse-transition">
      <v-card-actions v-if="description.model" class="px-0">
        <!--                @keydown.enter="reject"-->
        <v-textarea v-model="description.text" :error-messages="errors.description" append-icon="mdi-close"
                    class="m-3" label="توضیحات" outlined prepend-icon="mdi-send"
                    @click:append="description.model = false" @click:prepend="reject"/>
      </v-card-actions>
    </transition>

    <v-card-actions class="justify-space-around px-0">
      <v-btn :loading="loading" class="flex-50 btn-accept" elevation="0" large @click="accept">
        <v-icon class="ml-2">mdi-thumb-up</v-icon>
        تایید
      </v-btn>
      <v-btn :loading="loading" class="flex-50 btn-cancel" elevation="0" large
             @click="description.model = true">
        <v-icon class="ml-2">mdi-thumb-down</v-icon>
        رد کردن
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import UserDetails from "./userInfo/userDetails";
import RequestDetails from "./userInfo/requestDetails";
import Business from "./userInfo/Business";

export default {
  name: "showRequest",

  props: ['id'],

  components: {RequestDetails, UserDetails, Business},

  data: () => ({
    data: null,
    loading: false,
    description: {
      model: false,
      text: '',
    },

    errors: {},
  }),

  mounted() {
    this.fetch();
  },

  methods: {
    fetch() {
      this.loading = true;

      this.requestApiGet(`authRequest/${this.id}`)
          .then(({data}) => this.data = data)
          .finally(() => this.loading = false);
    },

    accept() {
      this.loading = true;

      this.requestApiPost('authRequest', {
        id: this.id,
        status: 'accept',
      })
          .then(({data}) => {
            if (data.message != null) this.$toast.success(data.message);
            else this.$toast.success('موفق');
            this.$router.replace('/user/confirmed');
          })
          .catch(({response}) => {
            if (response.data != null && response.data.message != null) this.$toast.error(response.data.message);
            else this.$toast.error('ناموفق');
            this.errors = response.data.errors;
          })
          .finally(() => this.loading = false);
    },

    reject() {

      if (this.description.text == null || this.description.text.length <= 0) {
        this.errors.description = ['لطفا توضیحات رد کردن درخواست را در نمایید.'];
        this.$forceUpdate();
        return;
      }
      this.loading = true;

      this.requestApiPost('authRequest', {
        id: this.id,
        status: 'edit',
        description: this.description.text,
      })
          .then(({data}) => {
            if (data.message != null) this.$toast.success(data.message);
            else this.$toast.success('موفق');
            this.$router.replace('/user/confirmed');
          })
          .catch(({response}) => {
            if (response.data != null && response.data.message != null) this.$toast.error(response.data.message);
            else this.$toast.error('ناموفق');
            this.errors = response.data.errors;
          })
          .finally(() => this.loading = false);
    }
  }
}
</script>

<style scoped>
.flex-50 {
  flex: 1 1 50%;
}

.priceWallet .v-input__control {
  min-width: 20px;
  min-height: 2.5rem !important;
  height: 2.5rem !important;
  background-color: rgba(256, 256, 256, 0.2) !important;
  color: white;
  /*background-color: hsla(0, 0%, 100%, 0.12) !important;*/
  width: 12vw;
  border-bottom-left-radius: 0;
  border-top-left-radius: 0;
}

.priceWallet .v-input__control .v-input__slot * {
  padding: 0 0.5rem;
  min-height: 2.5rem !important;
  height: 2.5rem !important;
  font-size: 1.2rem;
  font-weight: bold;
  color: white;
  font-family: 'vazir';
}

.priceWallet .v-input__control .v-input__slot {
  padding: 0 0.5rem;
  min-height: 2.5rem !important;
  height: 0rem !important;
  font-size: 1rem;
  margin: 0;
}

.priceWallet .v-input__control .v-input__slot:before {
  border-style: none
}

.priceWallet .v-input__control .v-input__slot:after {
  border-style: none
}

.priceWallet .v-input__control .v-input__prepend-inner {
  padding-left: 0;
}

.priceWallet .v-input__control .v-input__prepend-inner .append-icon {
  padding: 0;
}

.priceWallet .append-icon {
  background-color: white;
  -webkit-mask: url('/etebar.png') no-repeat center;
  mask: url('/etebar.png') no-repeat center;
  mask-size: 35px 20px;
  width: 45px;
  height: 20px !important;
}


.priceWallet .v-input__control .v-input__prepend-inner {
  margin-top: 0 !important;
}

.priceWallet .v-input__control .v-text-field__slot {
  font-size: 1rem;
  align-items: center;
  margin: 0;
  padding: 0;
}

.priceWallet .v-input__control .v-text-field__slot .v-text-field__prefix {
  margin-top: 0.3rem;
}

.priceWallet .v-input__control .v-input__slot .v-input__append-inner {
  margin: 0 !important;
  padding: 0 !important;
  font-size: 1.6rem;
}

.priceWallet .v-input__control .v-input__slot .v-input__append-inner .v-input__icon--append {
  margin: 0 !important;
  padding: 0 !important;
  font-size: 1.6rem;
}

.priceWallet .v-input__control .v-input__slot .v-input__append-inner .v-input__icon--append .v-icon {
  margin: 0 !important;
  padding: 0 !important;
  font-size: 1.6rem;
}


</style>
